import {
  React,
  useState,
  useEffect
} from 'react';

import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Tab, 
  Tabs,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import LoadingOverlay from 'react-loading-overlay-nextgen';
import PropTypes from 'prop-types';
import DriveButtons from 'src/components/dashboard/ControlComponents/DriveButtons';
import ModeButtons from 'src/components/dashboard/ControlComponents/ModeButtons';
import Viewfinder from 'src/components/dashboard/ControlComponents/Viewfinder';
import OrientationDisplay from 'src/components/dashboard/ControlComponents/OrientationDisplay';
import OperationModeDisplay from 'src/components/dashboard/ControlComponents/OperationModeDisplay';
import TemperatureDisplay from 'src/components/dashboard/ControlComponents/TemperatureDisplay';
import MotorStatusDisplay from 'src/components/dashboard/ControlComponents/MotorStatusDisplay';
import MiscDataDisplay from 'src/components/dashboard/ControlComponents/MiscDataDisplay';
import TrackingCalibrationPanel from 'src/components/dashboard/ControlComponents/TrackingCalibrationPanel';

import {wssUrl} from 'src/utils/constants';



const startConnection = async (token, deviceId, connection_id) => {
  let url = "https://api.solarflux-api.co/dishes/start-dish-connection/"+ deviceId

  const postData = {
    "connection_id": connection_id
  };


  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token
    },
    body: JSON.stringify(postData)
  }).then((response) => {
    if (response.ok){
      return response.json();
    }
    throw response;
  }).catch((err) => {
    console.error(err);
  });
};

const stopConnection = async (token, deviceId, connection_id) => {
  let url = "https://api.solarflux-api.co/dishes/stop-dish-connection/"+ deviceId

  const postData = {
    "connection_id": connection_id
  };


  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token
    },
    body: JSON.stringify(postData)
  }).then((response) => {
    if (response.ok){
      return 
    }
    throw response;
  }).catch((err) => {
    console.error(err);
  });
};


const ControlDashboard = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [overlayMessage, setOverlayMessage] = useState("Please select a dish")
  const [spinnerVisible, setSpinnerVisible] = useState(false);

  const { token ,deviceId } = props;

  const [auto_tracking, set_auto_tracking] = useState(false);
  const [up_left, set_up_left] = useState(false);
  const [up, set_up] = useState(false);
  const [up_right, set_up_right] = useState(false);
  const [left, set_left] = useState(false);
  const [toggle, set_toggle] = useState(false);
  const [right, set_right] = useState(false);
  const [down_left, set_down_left] = useState(false);
  const [down, set_down] = useState(false);
  const [down_right, set_down_right] = useState(false);
  
  const [speed, set_speed] = useState(0);
  
  const [wind_safe_mode_override, set_wind_safe_mode_override] = useState(false);
  const [stow_override, set_stow_override] = useState(false);
  const [maintenance_mode, set_maintenance_mode] = useState(false);
  const [refresh_config, set_refresh_config] = useState(false);
  const [calibrate_az, set_calibrate_az] = useState(false);
  const [calibrate_zen, set_calibrate_zen] = useState(false);

  const [vision_solar_azimuth, set_vision_solar_azimuth] = useState(0.00);
  const [vision_solar_zenith, set_vision_solar_zenith] = useState(0.00);

  const [dish_azimuth, set_dish_azimuth] = useState(0.00);
  const [dish_zenith, set_dish_zenith] = useState(0.00);

  const [solar_azimuth, set_solar_azimuth] = useState(0.00);
  const [solar_zenith, set_solar_zenith] = useState(0.00);

  const [target_azimuth, set_target_azimuth] = useState(0.00);
  const [target_zenith, set_target_zenith] = useState(0.00);

  const [inlet_temp, set_inlet_temp] = useState(16.00);

  const [outlet_temp, set_outlet_temp] = useState(16.00);

  const [az_tracking_offset, set_az_tracking_offset] = useState(0);
  const [zen_tracking_offset, set_zen_tracking_offset] = useState(0);

  const [azimuth_speed, set_azimuth_speed] = useState(0);
  const [azimuth_direction, set_azimuth_direction] = useState('forward');
  const [zenith_speed, set_zenith_speed] = useState(0);
  const [zenith_direction, set_zenith_direction] = useState('forward');

  const [wind_speed, set_wind_speed] = useState(0);
  const [last_updated, set_last_updated] = useState('00:00:00');
  const [camera_temp, set_camera_temp] = useState(0);
  const [sensor_dni, set_sensor_dni] = useState(0);
  const [network_status, set_network_status] = useState("ok");
  const [sum_of_image, set_sum_of_image] = useState(0);

  const [current_operation, set_current_operation] = useState("manual");

  var dashboardConnectionId = null;
  const [controllerConnectionId, setControllerConnectionID] = useState(null);

  const [webSocket, setWebSocket] = useState(null);


  function sendCommand(button, value){

    var command_payload = {
      "action": "sendmessage",
      "sourceConnectionId": dashboardConnectionId,
      "destinationConnectionId": controllerConnectionId,
      "message": JSON.stringify({[button]:value})
    }
     sendMessage(webSocket,command_payload);
     setIsLoading(true)
     setOverlayMessage("Sending Command...")
     setSpinnerVisible(true);
  } 

  const sendMessage = (socket, message) => {
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(message));
    } else {
      console.error('WebSocket is not open. Message not sent.');
    }
  };

  const interpretMessage = (message) => {
    if(message.hasOwnProperty('sourceConnectionId')){
      setIsLoading(false)  
      setControllerConnectionID(message.sourceConnectionId);
    }

    if(message.hasOwnProperty('auto_tracking')){
      set_auto_tracking(message.auto_tracking);
    }

    if(message.hasOwnProperty('up_left')){
      set_up_left(message.up_left);
    }

    if(message.hasOwnProperty('up')){
      set_up(message.up);
    }

    if(message.hasOwnProperty('up_right')){
      set_up_right(message.up_right);
    }

    if(message.hasOwnProperty('left')){
      set_left(message.left);
    }

    if(message.hasOwnProperty('toggle')){
      set_toggle(message.toggle);
    }

    if(message.hasOwnProperty('right')){
      set_right(message.right);
    }

    if(message.hasOwnProperty('down_left')){
      set_down_left(message.down_left);
    }

    if(message.hasOwnProperty('down_right')){
      set_down_right(message.down_right);
    }

    if(message.hasOwnProperty('speed')){
      set_speed(message.speed);
    }

    if(message.hasOwnProperty('wind_safe_mode_override')){
      set_wind_safe_mode_override(message.wind_safe_mode_override);
    }

    if(message.hasOwnProperty('stow_override')){
      set_stow_override(message.stow_override);
    }
    if(message.hasOwnProperty('maintenance_mode')){
      set_maintenance_mode(message.maintenance_mode);
    }

    if( message.hasOwnProperty('refresh_config')){
      set_refresh_config(message.refresh_config);
    }

    if( message.hasOwnProperty('calibrate_az')){
      set_calibrate_az(message.calibrate_az);
    }

    if( message.hasOwnProperty('calibrate_zen')){
      set_calibrate_zen(message.calibrate_zen);
    }

    if( message.hasOwnProperty('vision_solar_azimuth')){
      set_vision_solar_azimuth(message.vision_solar_azimuth);
    }

    if( message.hasOwnProperty('vision_solar_zenith')){
      set_vision_solar_zenith(message.vision_solar_zenith);
    }

    if( message.hasOwnProperty('calc_dish_azimuth')){ 
      set_dish_azimuth(message.calc_dish_azimuth);
    }

    if( message.hasOwnProperty('calc_dish_zenith')){
      set_dish_zenith(message.calc_dish_zenith);
    }

    if( message.hasOwnProperty('calc_solar_azimuth')){
      set_solar_azimuth(message.calc_solar_azimuth);
    }

    if( message.hasOwnProperty('calc_solar_zenith')){
      set_solar_zenith(message.calc_solar_zenith);
    }

    if( message.hasOwnProperty('target_azimuth')){
      set_target_azimuth(message.target_azimuth);
    }

    if( message.hasOwnProperty('target_zenith')){
      set_target_zenith(message.target_zenith);
    }

    if( message.hasOwnProperty('inlet_temp')){
      set_inlet_temp(message.inlet_temp);
    }

    if( message.hasOwnProperty('outlet_temp')){
      set_outlet_temp(message.outlet_temp);
    }

    if( message.hasOwnProperty('az_tracking_offset')){
      set_az_tracking_offset(message.az_tracking_offset);
    }

    if( message.hasOwnProperty('zen_tracking_offset')){
      set_zen_tracking_offset(message.zen_tracking_offset);
    }

    if( message.hasOwnProperty('az_motor_speed')){
      set_azimuth_speed(message.az_motor_speed);
    }

    if( message.hasOwnProperty('az_motor_direction')){
      set_azimuth_direction(message.az_motor_direction);
    }

    if( message.hasOwnProperty('zen_motor_speed')){
      set_zenith_speed(message.zen_motor_speed);
    }

    if( message.hasOwnProperty('zen_motor_direction')){
      set_zenith_direction(message.zen_motor_direction);
    }

    if( message.hasOwnProperty('wind_speed')){
      set_wind_speed(message.wind_speed);
    }

    if( message.hasOwnProperty('reading_time')){
      set_last_updated(message.reading_time);
    }

    if( message.hasOwnProperty('camera_pod_temp')){
       set_camera_temp(message.camera_pod_temp);
    }

    if( message.hasOwnProperty('dni_sensor_value')){
      set_sensor_dni(message.dni_sensor_value);
    }

    if( message.hasOwnProperty('network_status')){
      set_network_status(message.network_status);
    }

    if( message.hasOwnProperty('sum_image_brightness')){
      set_sum_of_image(message.sum_image_brightness);
    }

    if( message.hasOwnProperty('current_operation')){
      set_current_operation(message.current_operation);
    }
  };


  useEffect(() => { 
    const socket = new WebSocket(wssUrl);
    setWebSocket(socket);

    if (deviceId.length ==1){ // dont init websocket unless only one dish is selected
      setOverlayMessage("Connecting...")
      setSpinnerVisible(true);
      socket.onopen = () => {
        sendMessage(socket,"message"); // send generic message to get conectionID back
      };

      socket.onmessage = (event) => {
        const message = JSON.parse(event.data);

        if( dashboardConnectionId == null){
          dashboardConnectionId = (message.connectionID);
          startConnection(token, deviceId, dashboardConnectionId,setIsLoading )
          interpretMessage(message);
        }
        else{
          interpretMessage(message);
        }
      };

      // Event listener for connection errors
      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      // Event listener for when the connection is closed
      socket.onclose = (event) => {
        if (event.wasClean) {
          console.log('WebSocket connection closed cleanly');
        } else {
          console.error('WebSocket connection closed with an error');
        }
        console.log('WebSocket close code:', event.code, 'reason:', event.reason);
      };
    }

    const intervalId = setInterval(() => {
      if (dashboardConnectionId != null){
          console.log("checking in ")
          startConnection(token, deviceId, dashboardConnectionId);
      }

    }, 60 * 1000);


    return () => {
      clearInterval(intervalId);
      // Clean up the WebSocket connection when the component unmounts
      stopConnection(token, deviceId, dashboardConnectionId);
      socket.close();
    };

  }, [props]);


	return (
  		<Container maxWidth={true}>
         <Box
          sx={{
            height: '900px'
          }}
        >
         <LoadingOverlay
            active={isLoading}
            spinner={spinnerVisible}
            text={overlayMessage}
          >
        	<Grid
            	container
            	spacing={3}
          	>
            <Grid
              item
              xl={3}
              lg={3}
              md={6}
              xs={6}
            >
              <DriveButtons
                sendCommand={sendCommand}
                auto_tracking={auto_tracking}
                up_left={up_left}
                up={up}
                up_right={up_right}
                left={left}
                toggle={toggle}
                right={right}
                down_left={down_left}
                down={down}
                down_right={down_right}
              />
              <ModeButtons
                sendCommand={sendCommand}
                speed={speed}
                wind_safe_override={wind_safe_mode_override}
                stow_override={stow_override}
                maintenance_mode={maintenance_mode}
              />
              <br/>
              <Viewfinder x={vision_solar_azimuth} y={vision_solar_zenith}/>
            </Grid>
            <Grid
              item
              xl={3}
              lg={3}
              md={6}
              xs={6}
            >
              <OrientationDisplay 
                title="Dish Orientation" 
                azimuth={dish_azimuth} 
                zenith={dish_zenith}
              />
              <TemperatureDisplay 
                title="Inlet Temp"
                temp={inlet_temp}
              />
              <MotorStatusDisplay
                azimuth_speed={azimuth_speed}
                azimuth_direction={azimuth_direction}
                zenith_speed={zenith_speed}
                zenith_direction={zenith_direction}
              />
            </Grid>
            <Grid
              item
              xl={3}
              lg={3}
              md={6}
              xs={6}
            >
              <OrientationDisplay 
                title="Solar Position" 
                azimuth={solar_azimuth} 
                zenith={solar_zenith}/>
              <TemperatureDisplay 
                title="Outlet Temp" 
                temp={outlet_temp}
              />
              <MiscDataDisplay
                wind_speed={wind_speed}
                last_updated={last_updated}
                camera_temp={camera_temp}
                sensor_dni={sensor_dni}
                network_status={network_status}
                sum_of_image={sum_of_image}
              />
            </Grid>
            <Grid
              item
              xl={3}
              lg={3}
              md={6}
              xs={6}
            >
            <OrientationDisplay 
              title="Target Position" 
              azimuth={target_azimuth} 
              zenith={target_zenith}/>
            <TrackingCalibrationPanel
              az_tracking_offset={az_tracking_offset}
              zen_tracking_offset={zen_tracking_offset}
            />
            <OperationModeDisplay
              current_operation={current_operation}
            />
            </Grid>
        </Grid>
      </LoadingOverlay></Box>
    </Container>
	);
}

ControlDashboard.propTypes = {
  latest: PropTypes.object,
  token: PropTypes.string
};

export default ControlDashboard;